/* eslint-disable max-len */
import React from 'react';
import { AllieIconProps } from '../../..';

export const EfficiencyMenuSelectedMobileApp = (props: AllieIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3333 4.33337C16.8856 4.33337 17.3333 4.78109 17.3333 5.33337L17.3333 10.6667C17.3333 11.219 16.8856 11.6667 16.3333 11.6667C15.781 11.6667 15.3333 11.219 15.3333 10.6667L15.3333 5.33337C15.3333 4.78109 15.781 4.33337 16.3333 4.33337Z"
        fill={props.color || '#131316'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.95952 9.95952C5.35004 9.56899 5.98321 9.56899 6.37373 9.95952L9.70707 13.2929C10.0976 13.6834 10.0976 14.3165 9.70707 14.7071C9.31654 15.0976 8.68338 15.0976 8.29285 14.7071L4.95952 11.3737C4.56899 10.9832 4.56899 10.35 4.95952 9.95952Z"
        fill={props.color || '#131316'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.7071 9.95952C28.0976 10.35 28.0976 10.9832 27.7071 11.3737L24.3737 14.7071C23.9832 15.0976 23.35 15.0976 22.9595 14.7071C22.569 14.3165 22.569 13.6834 22.9595 13.2929L26.2929 9.95952C26.6834 9.56899 27.3165 9.56899 27.7071 9.95952Z"
        fill={props.color || '#131316'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33331 22.6666C3.33331 22.1143 3.78103 21.6666 4.33331 21.6666L8.33331 21.6666C8.8856 21.6666 9.33331 22.1143 9.33331 22.6666C9.33331 23.2189 8.8856 23.6666 8.33331 23.6666L4.33331 23.6666C3.78103 23.6666 3.33331 23.2189 3.33331 22.6666Z"
        fill={props.color || '#131316'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.831 13.6803C18.3758 13.7711 18.7438 14.2863 18.653 14.8311L17.3197 22.8311C17.2289 23.3758 16.7137 23.7438 16.1689 23.6531C15.6241 23.5623 15.2561 23.047 15.3469 22.5023L16.6802 14.5023C16.771 13.9575 17.2862 13.5895 17.831 13.6803Z"
        fill={props.color || '#131316'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.3333 22.6666C23.3333 22.1143 23.781 21.6666 24.3333 21.6666L28.3333 21.6666C28.8856 21.6666 29.3333 22.1143 29.3333 22.6666C29.3333 23.2189 28.8856 23.6666 28.3333 23.6666L24.3333 23.6666C23.781 23.6666 23.3333 23.2189 23.3333 22.6666Z"
        fill={props.color || '#131316'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3333 6.33337C9.52182 6.33337 4 11.8552 4 18.6667C4 21.2682 4.8044 23.6793 6.17838 25.668H11.6667C12.219 25.668 12.6667 26.1157 12.6667 26.668C12.6667 27.2203 12.219 27.668 11.6667 27.668H5.66667C5.35221 27.668 5.05606 27.5201 4.86717 27.2687C3.06709 24.8728 2 21.8929 2 18.6667C2 10.7506 8.41725 4.33337 16.3333 4.33337C24.2494 4.33337 30.6667 10.7506 30.6667 18.6667C30.6667 21.8929 29.5996 24.8728 27.7995 27.2687C27.6106 27.5202 27.3143 27.6681 26.9998 27.668L20.9998 27.6667C20.4475 27.6666 19.9999 27.2188 20 26.6665C20.0001 26.1142 20.4479 25.6666 21.0002 25.6667L26.4884 25.6679C27.8623 23.6792 28.6667 21.2681 28.6667 18.6667C28.6667 11.8552 23.1448 6.33337 16.3333 6.33337Z"
        fill={props.color || '#131316'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3333 23.6666C14.6765 23.6666 13.3333 25.0098 13.3333 26.6666C13.3333 28.3235 14.6765 29.6666 16.3333 29.6666C17.9902 29.6666 19.3333 28.3235 19.3333 26.6666C19.3333 25.0098 17.9902 23.6666 16.3333 23.6666ZM11.3333 26.6666C11.3333 23.9052 13.5719 21.6666 16.3333 21.6666C19.0947 21.6666 21.3333 23.9052 21.3333 26.6666C21.3333 29.4281 19.0947 31.6666 16.3333 31.6666C13.5719 31.6666 11.3333 29.4281 11.3333 26.6666Z"
        fill={props.color || '#131316'}
      />
    </svg>
  );
};
